import ModalComponent from '@/common/Modal';
import { Box, Spinner, Text } from '@chakra-ui/react';
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { callToGetEmailTemplate } from '../ducks/slice';
import { getEmailTamplate, getIsGetEmailTemplateLoading } from '../ducks/selectors';
import { Buffer } from 'buffer';

export interface ViewEmailModalProps {
    isOpen: boolean;
    onClose: () => void;
    emailId: string;
}

const ViewEmailModal = ({ isOpen, emailId = '', onClose }: ViewEmailModalProps) => {

    const dispatch = useDispatch();
    const isEmailTamplateLoading = getIsGetEmailTemplateLoading()
    const emailTamplate = getEmailTamplate()

    const onGetEmailTemplate = (id: string) => {
        dispatch(callToGetEmailTemplate({ emailId: id }))
    }

    useEffect(() => {
        if (emailId !== '') {
            onGetEmailTemplate(emailId);
        }
    }, [emailId])

    const getEmailHtmlContent = () => {
        if (emailTamplate && emailTamplate?.htmlContent?.data) {
            const htmlString = Buffer.from(emailTamplate?.htmlContent?.data).toString('utf8');
            return htmlString;
        }
        return '<p>No email content available</p>';
    };

    return (
        <ModalComponent
            title="View Email"
            isOpen={isOpen}
            onClose={onClose}
            variant={2}
            className="btns"
            footer={<></>}
            maxWidth="900px"
        >
            {!isEmailTamplateLoading ? (
                <Box className='mail-body'>
                    <Box sx={{width: '713px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: '2rem'}}>
                        <Text className='email-source' sx={{ paddingBottom: '0.5rem' }}><strong>Email Clicked Count:</strong><span style={{paddingLeft: '0.5rem'}}>{emailTamplate?.emailClickCounts}</span></Text>
                        <Text className='email-source' sx={{ paddingBottom: '0.5rem' }}><strong>Email Opend Count:</strong><span style={{paddingLeft: '0.5rem'}}>{emailTamplate?.emailOpenCounts}</span></Text>
                    </Box>
                    <Text className='email-source' sx={{ paddingBottom: '0.5rem' }}><strong>From:</strong> {emailTamplate?.sender}</Text>
                    <Text className='email-source' sx={{ paddingBottom: '0.5rem' }}><strong>To:</strong> {emailTamplate?.destinationAddress?.join(', ')}</Text>
                    <Text className='mail-subject' sx={{ paddingBottom: '1rem' }}>Subject: {emailTamplate?.subject}</Text>
                    <Box dangerouslySetInnerHTML={{ __html: getEmailHtmlContent() }}></Box>
                </Box>
            ) : (
                <Box sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    minHeight: "550px",
                }}>
                    <Spinner
                        className={`preview-loader`}
                        thickness={'4px'}
                        speed="0.65s"
                        emptyColor={'gray.200'}
                        color="#0C1E46"
                        size={'xl'}
                    />
                </Box>
            )}
        </ModalComponent>
    )
}

export default ViewEmailModal